import React, { Component } from 'react'

const HIT_TEST_OPTIONS = {
  segments: true,
  stroke: true,
  fill: true,
  tolerance: 5
}

export default function withPerspectiveTool(WrappedComponent) {
  return class PerspectiveTool extends Component {
    constructor(props) {
      super(props)
      this._changed = false
      this._item = null
      this._segment = null
      this._point = null
      this.paper = null
      this.state = {
        showCube: false
      }
    }

    perspectiveToolMouseDown = (e) => {
      this.paper = e.tool._scope
      const hit = e.tool.view._project.hitTest(e.point, HIT_TEST_OPTIONS)
      if (hit && hit.type === 'stroke') this.measurePointAngles(hit.item)
    }

    measurePointAngles = (item) => {
      var segments = item.segments
      var vectors = []
      //براساس نقاط هر ناحیه برداری رسم کن
      for (let index = 0; index < segments.length; index++) {
        var point1 = segments[index].point
        var point2 = segments[index].next.point
        var vector = point2 - point1
        vectors.push(vector)
      }

      var deviations = [] // لیست انحراف نقاط
      for (let index = 0; index < vectors.length; index++) {
        // دو بردار مجاور را انتخاب کن
        var vector1 = vectors[index]
        var vector2
        if (index === vectors.length - 1)
          // اگر به پایان مسیر رسیدیم نقاط مجاور می شود اولین نقطه
          vector2 = vectors[0]
        else vector2 = vectors[index + 1]

        // احتلاف زاویه دو بردار یا زاویه بین دو بردار با حساب کن
        var angle = vector2.angle - vector1.angle

        // چون زوایا در پیپر جی اس با محور افقی حساب می شوند
        // ممکن است زاوبیه بین دو بردار از 180 منفی کمتر شود
        // ما چون با قدر مطلق  زاویه انحراف کار داریم به 360 جمع میکنیم
        if (angle < -180) angle += 360

        // نقطه بعدی را دربیار
        var segment =
          index === vectors.length - 1 ? segments[0] : segments[index + 1]

        // به لیست انحرافات نقطه، زاویه و اندیس را بیفزا
        deviations.push({
          angle: angle,
          x: segment.point.x,
          y: segment.point.y,
          index: index
        })
      }

      // تا اینجای کار هر نقطه با زاویه ی آن  درآمد

      // مرتب سازی براساس برگترین زاویه انحراف
      deviations.sort(function (a, b) {
        return b.angle - a.angle
      })

      // 5 نقطه اول با بزرگترین زاویه انحراف را نگه دار
      deviations = deviations.slice(0, 5)

      // حالا این پنج نقطه را  براساس اندیس یا شماره نقطه مرتب کن
      deviations.sort(function (a, b) {
        return a.index - b.index
      })

      // در اینجا از بین 5 نقطه 1 نقطه را حذف کن
      deviations = this.removeOutlier(deviations)

      // پس تا اینجا 4 نقطه تمیز با بیشترین انحراف را داریم

      // رسم مسیر بسته پرسپکتیو
      var path = new this.paper.Path()
      path.closed = true
      var points = []
      for (var i = 0; i < 4; i++) {
        var point = new this.paper.Point({
          x: deviations[i].x,
          y: deviations[i].y
        })
        path.add(point)
        points.push(point)
      }

      //path.layer.data.id = 2
      const pathItem = this.props.addItem(path.layer, {
        type: 'Path',
        pathData: path.getPathData(),
        strokeColor: '#00ff00',
        strokeScaling: false,
        strokeWidth: 2,
        opacity: 0.5,
        fillColor: 'yellow',
        closed: true
      })
      this.props.selectItem(pathItem)

      // رسم خطوط راهنمای پرسپکتیو
      this.drawPerspectiveGuideLines(points)
    }

    drawPerspectiveGuideLines = (points) => {
      // تابع زیر یک نقطه بین دو نقط ورودی پیدا می کند است
      // interpolate
      var interpolatedPoints = []
      for (var index = 0; index < points.length; index++) {
        var point = this.interpolate(
          points[index],
          points[index === points.length - 1 ? 0 : index + 1],
          0.5
        )
        // چهار نقطه وسطی اضافه می شوند
        interpolatedPoints.push(point)
      }

      for (let index = 0; index < points.length; index++) {
        // بین نقطه اول و جدید
        let point = this.interpolate(
          points[index],
          interpolatedPoints[index],
          0.5
        )
        interpolatedPoints.push(point)

        // بین نقطه جدید و آخر
        point = this.interpolate(
          points[index === points.length - 1 ? 0 : index + 1],
          interpolatedPoints[index],
          0.5
        )
        interpolatedPoints.push(point)
      }

      // تا اینجا نقاط درونیابی شده را داریم

      // // ابتدا دایره های سبز رنگ مربوط به هر نقطه را رسم می کنیم
      // for (let index = 0; index < interpolatedPoints.length; index++) {
      //   var shape = new this.paper.Shape.Circle(interpolatedPoints[index], 2)
      //   shape.fillColor = 'green'
      // }

      // // نوشته های روی نقاط سبز رنگ
      // for (let index = 0; index < interpolatedPoints.length; index++) {
      //   const shape = new this.paper.Shape.Circle(interpolatedPoints[index], 2)
      //   new this.paper.PointText(
      //     interpolatedPoints[index] + new this.paper.Point(5, 5)
      //   ).content = index.toString()
      //   shape.fillColor = 'green'
      // }

      // رسم خطوط بین نقاط سبز
      // همیشه هر دو جفت زیر روی به روی هم هستند
      // new this.paper.Path.Line(
      //   interpolatedPoints[7],
      //   interpolatedPoints[10]
      // ).strokeColor = 'green'
      // new this.paper.Path.Line(
      //   interpolatedPoints[1],
      //   interpolatedPoints[3]
      // ).strokeColor = 'green'
      // new this.paper.Path.Line(
      //   interpolatedPoints[6],
      //   interpolatedPoints[11]
      // ).strokeColor = 'green'
      // new this.paper.Path.Line(
      //   interpolatedPoints[5],
      //   interpolatedPoints[8]
      // ).strokeColor = 'green'
      // new this.paper.Path.Line(
      //   interpolatedPoints[0],
      //   interpolatedPoints[2]
      // ).strokeColor = 'green'
      // new this.paper.Path.Line(
      //   interpolatedPoints[4],
      //   interpolatedPoints[9]
      // ).strokeColor = 'green'
    }

    // تابع درون یابی
    interpolate = (a, b, t) => {
      return new this.paper.Point(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t)
    }

    // تابع حذف نقاط پرت
    removeOutlier = (deviations) => {
      var distances = []

      for (var index = 0; index < deviations.length; index++) {
        var point1 = deviations[index]
        var point2
        if (index === deviations.length - 1) point2 = deviations[0]
        else point2 = deviations[index + 1]

        // فاصله بین هر دو نقطه را حساب کن
        var value =
          Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2)
        distances.push({ index: index, value: value })
      }

      // مرتب سازی براساس اندازه فواصل
      distances.sort(function (a, b) {
        return a.value - b.value
      })

      // حذف کمترین اندازه
      deviations.splice(distances[0].index, 1)

      return deviations
    }

    render() {
      return (
        <WrappedComponent
          {...this.props}
          {...this.state}
          perspectiveToolMouseDown={this.perspectiveToolMouseDown}
        />
      )
    }
  }
}
